export default "__VITE_ASSET__CPGnHF3u__"